export class ItemOverviewHeaderField {
    constructor(readonly caption: string) {
    }
}
